<template>
	<div class="NewOrderHOV2">
		<div class="box-card-style">
			<div class="new-order-heading-section">
				<p class="mr-4 text-xl">
					New Order
				</p>
				<div>
					<el-select
						v-model="placeOrder"
						style="min-width: 150px; max-width: 300px;"
						placeholder="Order Status"
					>
						<el-option value="OrderStatus">
							Order Status
						</el-option>
					</el-select>
				</div>
			</div>
			<el-row :gutter="20" class="mt-2">
				<el-col :xs="24" :sm="24" :md="17" :lg="17" :xl="17" class="left-side">
					<div class="">
						<div class="if-not">
							<BaseButton buttonclass="btn p-2 text-xs">
								Step 1
							</BaseButton>
						</div>
						<simplebar class="simplebar">
							<table class="tableMain">
								<thead>
									<tr>
										<th colspan="1">
											Item Code
										</th>
										<th colspan="1">
											Item Name
										</th>
										<th colspan="2">
											Forecast Quantity
										</th>
										<th colspan="2">
											In Stock
										</th>
										<th colspan="2">
											Piepline Quantity
										</th>
										<th colspan="1">
											Arrival Date
										</th>
										<th colspan="1">
											Order Quantity
										</th>
										<th colspan="1">
											Order/Issue Unit
										</th>
										<th colspan="1">
											Return
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in newOrdeHOList" :key="index">
										<td>
											<BaseInput v-model="item.itemCode" placeholder="Item" />
										</td>
										<td>
											<BaseInput
												v-model="item.itemName"
												placeholder="ItemName"
											/>
										</td>
										<td class="custom-elementUi-css">
											<el-input-number v-model="item.forecastQty" size="mini" />
										</td>
										<td>
											<BaseInput
												v-model="item.forecastUnit"
												placeholder="Unit Price"
											/>
										</td>
										<td class="custom-elementUi-css">
											<el-input-number v-model="item.inStockQty" size="mini" />
										</td>
										<td>
											<BaseInput
												v-model="item.inStockUnit"
												placeholder="Unit"
											/>
										</td>
										<td class="custom-elementUi-css">
											<el-input-number v-model="item.pipelineQty" size="mini" />
										</td>
										<td>
											<BaseInput
												v-model="item.pipelineUnit"
												placeholder="Unit"
											/>
										</td>
										<td class="custom-elementUi-css">
											<el-date-picker
												v-model="item.arrivalDate"
												size="mini"
												type="date"
												placeholder="Date"
											/>
										</td>
										<td class="custom-elementUi-css">
											<el-input-number v-model="item.orderQty" size="mini" />
										</td>
										<td>
											<BaseInput v-model="item.issueUnit" placeholder="Unit" />
										</td>
										<td>
											<el-checkbox
												v-model="item.returnChecked"
												:border="true"
												size="mini"
												true-label="all"
												false-label="none"
											>
												<p v-if="item.returnChecked == 'all'">
													&nbsp;&nbsp;Yes
												</p>
												<p v-if="item.returnChecked == 'none'">
													&nbsp;&nbsp;&nbsp;No
												</p>
											</el-checkbox>
										</td>
									</tr>
								</tbody>
							</table>
						</simplebar>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="right-side">
					<div class="right-side-card">
						<div class="bg-white">
							<div class="card-heading-bg text-white h-10 p-2 pb-4 text-base">
								Summary
							</div>
							<table class="tableMain">
								<thead>
									<tr>
										<th colspan="1">
											Item Name
										</th>
										<th colspan="1">
											Order Quantity
										</th>
										<th colspan="2">
											Amount
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											abcd
										</td>
										<td>
											16
										</td>
										<td>
											Rs 80
										</td>
										<td>
											Rs 10
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="text-sm text-bold m-2 mt-4">
							Returned Products
						</div>
						<table class="tableMain bg-white">
							<thead>
								<tr>
									<th colspan="1">
										Item Name
									</th>
									<th colspan="1">
										Order Quantity
									</th>
									<th colspan="2">
										Amount
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										abcd
									</td>
									<td>
										16
									</td>
									<td>
										Rs 80
									</td>
									<td>
										Rs 10
									</td>
								</tr>
							</tbody>
						</table>
						<div class="text-bold m-2 text-sm">
							Total:
							<span class="float-right pr-4">
								Rs. 1009
							</span>
						</div>
					</div>

					<div class="right-side-card mt-6">
						<div class="bg-white">
							<div class="card-heading-bg text-white h-10 p-2 pb-4 text-base">
								Special Instruction
							</div>
							<div class="p-2">
								<textarea
									class="w-full mt-4 h-16 special-instruction-textarea"
								/>
								<div class="new-order-heading-section">
									<p class="mr-4 text-sm">
										Set Delivery Time
									</p>
									<div>
										<el-date-picker
											v-model="date"
											type="date"
											size="medium"
											style="min-width: 100px"
											placeholder="Pick a day"
										/>
									</div>
								</div>
								<div class="new-order-heading-section">
									<p class="mr-4 text-sm">
										From
									</p>
									<div>
										<el-time-select
											v-model="startTime"
											placeholder="00.00"
											size="medium"
											format="hh:mm A"
											value-format="hh:mm A"
										/>
									</div>
								</div>
								<div class="new-order-heading-section">
									<p class="mr-4 text-sm">
										To
									</p>
									<div>
										<el-time-select
											v-model="endTime"
											class="w-24"
											placeholder="00.00"
											size="medium"
											format="hh:mm A"
											value-format="hh:mm A"
										/>
									</div>
								</div>
								<el-checkbox
									v-model="checked"
									class="mt-4"
									:border="true"
									size="medium"
									true-label="all"
									false-label="none"
								>
									<p>
										&nbsp;&nbsp;Send For Approval
									</p>
								</el-checkbox>
								<div class="btn-Ingredient mt-4 w-16">
									<BaseButton
										type="submit"
										buttonclass="btn p-2 text-xs mr-8"
										@click="dialogVisible = true"
									>
										Send
									</BaseButton>
								</div>
								<el-dialog
									:visible.sync="dialogVisible"
									width="60%"
									:before-close="closedialogVisible"
								>
									<NewOrderSendPopup />
								</el-dialog>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import NewOrderSendPopup from "./NewOrderSendPopup";

export default {
	name: "NewOrderHOV2",
	components: {
		NewOrderSendPopup,
		simplebar
	},
	mixins: [],
	props: [],
	data() {
		return {
			placeOrder: "",
			checked: "all",
			date: "",
			startTime: "",
			endTime: "",
			newOrdeHOList: [
				{
					itemCode: "",
					itemName: "",
					forecastQty: 2,
					forecastUnit: "",
					amount: "",
					recivedQty: "",
					inStockQty: 3,
					inStockUnit: "",
					pipelineQty: 4,
					pipelineUnit: "",
					arrivalDate: "",
					orderQty: 3,
					issueUnit: "",
					returnChecked: "all"
				},
				{
					itemCode: "",
					itemName: "",
					forecastQty: 2,
					forecastUnit: "",
					amount: "",
					recivedQty: "",
					inStockQty: 3,
					inStockUnit: "",
					pipelineQty: 4,
					pipelineUnit: "",
					arrivalDate: "",
					orderQty: 3,
					issueUnit: "",
					returnChecked: "all"
				}
			],
			dialogVisible: false
		};
	},
	methods: {
		closedialogVisible() {
			this.dialogVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./NewOrderHOV2.scss";
</style>

<style>
.NewOrderHOV2 .el-dialog {
	margin-top: 0 !important;
}
.NewOrderHOV2 .Baseinput input {
	height: 30px !important;
	width: 80px;
}
</style>
